module.exports = __webpack_public_path__ + "static/media/Umar Taj.ae2f5462.jpeg";